module.exports = __webpack_public_path__ + "img/all-ticket-types.ef8e69f8.svg";